import axios from "axios";
import JwtService from "@/common/jwt.service";
import { API_URL } from "@/common/config";
import store from "@/store";
import { PURGE_AUTH } from "@/store/auth.module";
import { SET_ISLOADING } from "@/store/spin.module";
import route from "@/router";
import qs from "qs";
import SessionTimeoutService from "@/common/session-timeout.service";

let ApiService = axios.create({
  baseURL: API_URL,
  timeout: 60000,
});

// request interceptor
ApiService.interceptors.request.use(
  (config) => {
    // console.log(getToken())
    store.dispatch(SET_ISLOADING, true);
    config.headers["x-token"] = JwtService.getToken();
    config.data = qs.stringify(config.data);
    return config;
  },
  (error) => {
    //console.log(error); // for debug
    return Promise.reject(error);
  }
);

// Keep the existing JSON contract for callers when the server reports an
// authentication/authorization failure with its correct HTTP status.
const publicAuthActions = [
  "login", "adminlogin_step1", "adminlogin_step2",
  "resetAdminPassword", "startResetAdminPassword", "verifyAdminPasswordResetMfa",
];

function handleResponse(response) {
  store.dispatch(SET_ISLOADING, false);
  const data = response.data;
  const requestData = qs.parse((response.config && response.config.data) || "");
  const publicAuth = publicAuthActions.includes(requestData.action);
  if (data.error_code === "mfa_enrollment_required") {
    if (route.currentRoute.path !== "/mfa-enrollment") {
      route.replace("/mfa-enrollment").catch(() => {});
    }
    return data;
  }
  if (
    !publicAuth &&
    (response.status === 401 ||
      data.returndata === "Invalid login or your Session expired. Please log in again.")
  ) {
    // An expired session cannot authenticate a logout request. Clear locally
    // without making another API call, which would itself return 401.
    store.commit(PURGE_AUTH, { returndata: "success" });
    if (requestData.action === "logout") return data;
    if (route.currentRoute.path !== "/login") {
      route.replace({ name: "login" }).catch(() => {});
    }
    return Promise.reject(new Error("Session expired"));
  }
  if (
    requestData.token &&
    requestData.action !== "logout" &&
    data.returncode
  ) {
    SessionTimeoutService.refreshSessionTimeout();
  }
  return data;
}

// response interceptor
ApiService.interceptors.response.use(handleResponse, (error) => {
  const response = error.response;
  if (
    response &&
    (response.status === 401 || response.status === 403) &&
    response.data &&
    typeof response.data === "object" &&
    response.data.returncode === 0
  ) {
    return handleResponse(response);
  }
  store.dispatch(SET_ISLOADING, false);
  return Promise.reject(error);
});

export default ApiService;
